import React, { useState } from 'react';
import '../styles/AgeVerification.css';

const AgeVerification = ({ onVerify }) => {
  const [month, setMonth] = useState('');
  const [year, setYear] = useState('');

  const months = [
    { value: '01', label: 'يناير' },
    { value: '02', label: 'فبراير' },
    { value: '03', label: 'مارس' },
    { value: '04', label: 'أبريل' },
    { value: '05', label: 'مايو' },
    { value: '06', label: 'يونيو' },
    { value: '07', label: 'يوليو' },
    { value: '08', label: 'أغسطس' },
    { value: '09', label: 'سبتمبر' },
    { value: '10', label: 'أكتوبر' },
    { value: '11', label: 'نوفمبر' },
    { value: '12', label: 'ديسمبر' },
  ];
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: currentYear - 1899 }, (_, i) => currentYear - i);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (month && year) {
      const birthDate = new Date(year, parseInt(month) - 1, 1);
      const today = new Date();
      const age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();
      
      let actualAge = age;
      // If the birthday hasn't occurred yet this year (based on month), subtract one year
      if (monthDiff < 0) {
        actualAge--;
      }

      if (actualAge >= 18) {
        onVerify();
      } else {
        alert('يجب أن يكون عمرك 18 عاماً على الأقل للوصول إلى هذا الموقع.');
      }
    }
  };

  return (
    <div className="age-verification">
      <div className="age-verification-container">
        <div className="iqos-logo">
          <img src={`${process.env.PUBLIC_URL}/images/logo.png`} alt="Logo" />
        </div>
        <h2>
          يرجى إدخال تاريخ ميلادك لتأكيد أنك بالغ / مستخدم لمنتجات تحتوي على النيكوتين.
        </h2>
        <form onSubmit={handleSubmit} className="age-form">
          <div className="date-selectors">
            <div className="date-selector">
              <label>الشهر</label>
              <select value={month} onChange={(e) => setMonth(e.target.value)} required>
                <option value="">اختر</option>
                {months.map((m) => (
                  <option key={m.value} value={m.value}>
                    {m.label}
                  </option>
                ))}
              </select>
            </div>
            <div className="date-selector">
              <label>السنة</label>
              <select value={year} onChange={(e) => setYear(e.target.value)} required>
                <option value="">اختر</option>
                {years.map((y) => (
                  <option key={y} value={y}>
                    {y}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="form-buttons">
            <button type="submit" className="btn-confirm">تأكيد</button>
            <button 
              type="button" 
              className="btn-underage"
              onClick={() => alert('يجب أن يكون عمرك 18 عاماً على الأقل للوصول إلى هذا الموقع.')}
            >
              أنا أقل من 18 سنة
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AgeVerification;

